import { getCurrentScope as U, onScopeDispose as q, unref as B, onMounted as C, nextTick as K, getCurrentInstance as R, computed as x, ref as b, watchEffect as V, watch as N, reactive as D } from "vue";
function H(t) {
  return U() ? (q(t), !0) : !1;
}
function I(t) {
  return typeof t == "function" ? t() : B(t);
}
const F = typeof window < "u" && typeof document < "u";
typeof WorkerGlobalScope < "u" && globalThis instanceof WorkerGlobalScope;
const Y = Object.prototype.toString, z = (t) => Y.call(t) === "[object Object]", A = () => {
}, G = /* @__PURE__ */ Q();
function Q() {
  var t, n;
  return F && ((t = window == null ? void 0 : window.navigator) == null ? void 0 : t.userAgent) && (/iP(?:ad|hone|od)/.test(window.navigator.userAgent) || ((n = window == null ? void 0 : window.navigator) == null ? void 0 : n.maxTouchPoints) > 2 && /iPad|Macintosh/.test(window == null ? void 0 : window.navigator.userAgent));
}
function J(t) {
  return t || R();
}
function $(t, n = !0, e) {
  J() ? C(t, e) : n ? t() : K(t);
}
function M(t) {
  var n;
  const e = I(t);
  return (n = e == null ? void 0 : e.$el) != null ? n : e;
}
const T = F ? window : void 0;
function S(...t) {
  let n, e, i, a;
  if (typeof t[0] == "string" || Array.isArray(t[0]) ? ([e, i, a] = t, n = T) : [n, e, i, a] = t, !n)
    return A;
  Array.isArray(e) || (e = [e]), Array.isArray(i) || (i = [i]);
  const u = [], o = () => {
    u.forEach((w) => w()), u.length = 0;
  }, c = (w, E, r, d) => (w.addEventListener(E, r, d), () => w.removeEventListener(E, r, d)), l = N(
    () => [M(n), I(a)],
    ([w, E]) => {
      if (o(), !w)
        return;
      const r = z(E) ? { ...E } : E;
      u.push(
        ...e.flatMap((d) => i.map((h) => c(w, d, h, r)))
      );
    },
    { immediate: !0, flush: "post" }
  ), v = () => {
    l(), o();
  };
  return H(v), v;
}
let W = !1;
function re(t, n, e = {}) {
  const { window: i = T, ignore: a = [], capture: u = !0, detectIframe: o = !1 } = e;
  if (!i)
    return A;
  G && !W && (W = !0, Array.from(i.document.body.children).forEach((r) => r.addEventListener("click", A)), i.document.documentElement.addEventListener("click", A));
  let c = !0;
  const l = (r) => a.some((d) => {
    if (typeof d == "string")
      return Array.from(i.document.querySelectorAll(d)).some((h) => h === r.target || r.composedPath().includes(h));
    {
      const h = M(d);
      return h && (r.target === h || r.composedPath().includes(h));
    }
  }), w = [
    S(i, "click", (r) => {
      const d = M(t);
      if (!(!d || d === r.target || r.composedPath().includes(d))) {
        if (r.detail === 0 && (c = !l(r)), !c) {
          c = !0;
          return;
        }
        n(r);
      }
    }, { passive: !0, capture: u }),
    S(i, "pointerdown", (r) => {
      const d = M(t);
      c = !l(r) && !!(d && !r.composedPath().includes(d));
    }, { passive: !0 }),
    o && S(i, "blur", (r) => {
      setTimeout(() => {
        var d;
        const h = M(t);
        ((d = i.document.activeElement) == null ? void 0 : d.tagName) === "IFRAME" && !(h != null && h.contains(i.document.activeElement)) && n(r);
      }, 0);
    })
  ].filter(Boolean);
  return () => w.forEach((r) => r());
}
const X = 500, Z = 10;
function se(t, n, e) {
  var i, a;
  const u = x(() => M(t));
  let o, c, l, v = !1;
  function w() {
    o && (clearTimeout(o), o = void 0), c = void 0, l = void 0, v = !1;
  }
  function E(s) {
    var p, y, _;
    const [L, g, P] = [l, c, v];
    if (w(), !(e != null && e.onMouseUp) || !g || !L || (p = e == null ? void 0 : e.modifiers) != null && p.self && s.target !== u.value)
      return;
    (y = e == null ? void 0 : e.modifiers) != null && y.prevent && s.preventDefault(), (_ = e == null ? void 0 : e.modifiers) != null && _.stop && s.stopPropagation();
    const O = s.x - g.x, k = s.y - g.y, j = Math.sqrt(O * O + k * k);
    e.onMouseUp(s.timeStamp - L, j, P);
  }
  function r(s) {
    var p, y, _, L;
    (p = e == null ? void 0 : e.modifiers) != null && p.self && s.target !== u.value || (w(), (y = e == null ? void 0 : e.modifiers) != null && y.prevent && s.preventDefault(), (_ = e == null ? void 0 : e.modifiers) != null && _.stop && s.stopPropagation(), c = {
      x: s.x,
      y: s.y
    }, l = s.timeStamp, o = setTimeout(
      () => {
        v = !0, n(s);
      },
      (L = e == null ? void 0 : e.delay) != null ? L : X
    ));
  }
  function d(s) {
    var p, y, _, L;
    if ((p = e == null ? void 0 : e.modifiers) != null && p.self && s.target !== u.value || !c || (e == null ? void 0 : e.distanceThreshold) === !1)
      return;
    (y = e == null ? void 0 : e.modifiers) != null && y.prevent && s.preventDefault(), (_ = e == null ? void 0 : e.modifiers) != null && _.stop && s.stopPropagation();
    const g = s.x - c.x, P = s.y - c.y;
    Math.sqrt(g * g + P * P) >= ((L = e == null ? void 0 : e.distanceThreshold) != null ? L : Z) && w();
  }
  const h = {
    capture: (i = e == null ? void 0 : e.modifiers) == null ? void 0 : i.capture,
    once: (a = e == null ? void 0 : e.modifiers) == null ? void 0 : a.once
  }, m = [
    S(u, "pointerdown", r, h),
    S(u, "pointermove", d, h),
    S(u, ["pointerup", "pointerleave"], E, h)
  ];
  return () => m.forEach((s) => s());
}
function ee() {
  const t = b(!1), n = R();
  return n && C(() => {
    t.value = !0;
  }, n), t;
}
function te(t) {
  const n = ee();
  return x(() => (n.value, !!t()));
}
function ne(t, n = {}) {
  const { window: e = T } = n, i = te(() => e && "matchMedia" in e && typeof e.matchMedia == "function");
  let a;
  const u = b(!1), o = (v) => {
    u.value = v.matches;
  }, c = () => {
    a && ("removeEventListener" in a ? a.removeEventListener("change", o) : a.removeListener(o));
  }, l = V(() => {
    i.value && (c(), a = e.matchMedia(I(t)), "addEventListener" in a ? a.addEventListener("change", o) : a.addListener(o), u.value = a.matches);
  });
  return H(() => {
    l(), c(), a = void 0;
  }), u;
}
function le(t, n = {}) {
  const {
    delayEnter: e = 0,
    delayLeave: i = 0,
    window: a = T
  } = n, u = b(!1);
  let o;
  const c = (l) => {
    const v = l ? e : i;
    o && (clearTimeout(o), o = void 0), v ? o = setTimeout(() => u.value = l, v) : u.value = l;
  };
  return a && (S(t, "mouseenter", () => c(!0), { passive: !0 }), S(t, "mouseleave", () => c(!1), { passive: !0 })), u;
}
const oe = {
  ctrl: "control",
  command: "meta",
  cmd: "meta",
  option: "alt",
  up: "arrowup",
  down: "arrowdown",
  left: "arrowleft",
  right: "arrowright"
};
function ae(t = {}) {
  const {
    reactive: n = !1,
    target: e = T,
    aliasMap: i = oe,
    passive: a = !0,
    onEventFired: u = A
  } = t, o = D(/* @__PURE__ */ new Set()), c = {
    toJSON() {
      return {};
    },
    current: o
  }, l = n ? D(c) : c, v = /* @__PURE__ */ new Set(), w = /* @__PURE__ */ new Set();
  function E(m, f) {
    m in l && (n ? l[m] = f : l[m].value = f);
  }
  function r() {
    o.clear();
    for (const m of w)
      E(m, !1);
  }
  function d(m, f) {
    var s, p;
    const y = (s = m.key) == null ? void 0 : s.toLowerCase(), L = [(p = m.code) == null ? void 0 : p.toLowerCase(), y].filter(Boolean);
    y && (f ? o.add(y) : o.delete(y));
    for (const g of L)
      w.add(g), E(g, f);
    y === "meta" && !f ? (v.forEach((g) => {
      o.delete(g), E(g, !1);
    }), v.clear()) : typeof m.getModifierState == "function" && m.getModifierState("Meta") && f && [...o, ...L].forEach((g) => v.add(g));
  }
  S(e, "keydown", (m) => (d(m, !0), u(m)), { passive: a }), S(e, "keyup", (m) => (d(m, !1), u(m)), { passive: a }), S("blur", r, { passive: !0 }), S("focus", r, { passive: !0 });
  const h = new Proxy(
    l,
    {
      get(m, f, s) {
        if (typeof f != "string")
          return Reflect.get(m, f, s);
        if (f = f.toLowerCase(), f in i && (f = i[f]), !(f in l))
          if (/[+_-]/.test(f)) {
            const y = f.split(/[+_-]/g).map((_) => _.trim());
            l[f] = x(() => y.every((_) => I(h[_])));
          } else
            l[f] = b(!1);
        const p = Reflect.get(m, f, s);
        return n ? I(p) : p;
      }
    }
  );
  return h;
}
function ue(t = {}) {
  const {
    window: n = T,
    initialWidth: e = Number.POSITIVE_INFINITY,
    initialHeight: i = Number.POSITIVE_INFINITY,
    listenOrientation: a = !0,
    includeScrollbar: u = !0
  } = t, o = b(e), c = b(i), l = () => {
    n && (u ? (o.value = n.innerWidth, c.value = n.innerHeight) : (o.value = n.document.documentElement.clientWidth, c.value = n.document.documentElement.clientHeight));
  };
  if (l(), $(l), S("resize", l, { passive: !0 }), a) {
    const v = ne("(orientation: portrait)");
    N(v, () => l());
  }
  return { width: o, height: c };
}
export {
  le as a,
  se as b,
  ue as c,
  ae as d,
  re as o,
  ne as u
};
